import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';

export function useCaptchaEnabled(): boolean {
	const {
		data: {
			petition: { requireHumanVerification },
		},
	} = usePetitionDetailsPageData();

	return requireHumanVerification;
}
